<template>
    <div class="projectsList">
        <template v-for="(p, index) in projectsList">
            <Project :datas="{p}" :index="{index}" />
        </template>
    </div>
</template>

<script>
import {TweenMax} from 'gsap'
import Rellax from 'rellax'

import projectsList from './projects'
import Project from '../Project/Project'

export default {
    name: 'Projects',
    data () {
        return {
            projectsList,
            isScrolling: false
        }
    },
    components: {
        Project
    },
    mounted: function(){
        this.showPage()
        window.addEventListener('resize', this.setParallax);
        window.addEventListener('scroll', this.hideScrollIndicator);
    },
    methods: {
        setParallax: function(){
            if(this.rellaxEvt)
                this.rellaxEvt.destroy();

            this.rellaxEvt = new Rellax('.rellax', {
                center: true
            });
        },
        showPage: function(){
            TweenMax.to(this.$el.querySelectorAll('.projectSlide'), 0.8, {opacity: 1, y: 0, delay: 0.8, ease: Power2.easeOut, onComplete: _ => {
                this.setParallax()
                TweenMax.to(document.querySelectorAll('.firstLine'), 0.5, {y: 0, ease: Power2.easeOut})
                TweenMax.to(document.querySelectorAll('.lastLine'), 0.5, {y: 0, ease: Power2.easeOut, delay: 0.1})
                TweenMax.to(document.querySelectorAll('.projectNumber'), 0.6, {x: 0, opacity: 1, ease: Power2.easeOut})
                TweenMax.to(document.querySelector('.scrollIndicator'), 0.5, {autoAlpha: 1})
            }})
        },
        hideScrollIndicator: function(){
            if(this.isScrolling)
                return

            this.isScrolling = true
            TweenMax.to(document.querySelector('.scrollIndicator'), 0.5, {autoAlpha: 0})
        }
    },
    beforeRouteLeave (to, from, next) {
        TweenMax.to(document.querySelectorAll('.projectNumber'), 0.8, {x: '50%', opacity: 0, ease: Power2.easeOut})
        TweenMax.to(document.querySelectorAll('.lastLine'), 0.6, {y: '120%', ease: Power2.easeOut, delay: 0.1})
        TweenMax.to(document.querySelectorAll('.firstLine'), 0.6, {y: '120%', ease: Power2.easeOut,  onComplete: _ =>{
            // TweenMax.to(this.$el.querySelector('.fullBg'), 1, {background: '#161616'})
            TweenMax.staggerTo(this.$el.querySelectorAll('.projectSlide'), 1, {opacity: 0, y: -200, ease: Quint.easeOut}, 0.2, next)
        }})
    },
    beforeDestroy: function(){
        this.rellaxEvt.destroy();
        window.removeEventListener('resize', this.setParallax);
        window.addEventListener('scroll', this.hideScrollIndicator);
    }
}
</script>

<style lang="scss">
    @import './projects';
</style>



// WEBPACK FOOTER //
// src/components/Projects/Projects.vue